import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import MultiSelectInfiniteList from '../../../../../components/MultiSelectInfiniteList';
import {
  checkCompanyInsured,
  getCompanyInsureds,
  selectCompanyInsuredsList,
  setJobsButtonPulse
} from '../../../../../redux/modules/jobs';
import { useCompanyInsureds } from '../../../../../services/company-service';
import { getInfiniteListData } from '../../../../../services/util';
import { debounce } from '../../../../../utils/debounce';

import EmptyInsuredsList from './EmptyInsuredsList';

const MultiSelectInsureds = () => {
  const dispatch = useDispatch();
  const { companyId } = useParams();
  const { selected, buttonPulse } = useSelector(selectCompanyInsuredsList);
  const [searchInput, setSearchInput] = useState('');

  const {
    data: rqData,
    isLoading: rqIsLoading,
    fetchNextPage,
    hasNextPage
  } = useCompanyInsureds({
    companyId,
    searchTerm: searchInput
  });

  const livingData = useMemo(() => getInfiniteListData(rqData), [rqData]);

  const fetchData = value => {
    dispatch(getCompanyInsureds(
      companyId,
      { pageSize: 25, pageNumber: 1 },
      { ...(value && { insured_company_name: value }) }
    ));
  };

  const handlePopoverButtonClick = () => {
    if (buttonPulse) {
      dispatch(setJobsButtonPulse(false));
    }
  };

  const onSearchTermChange = debounce(value => setSearchInput(value), 700);

  const onSelect = (insured, isChecked) => dispatch(checkCompanyInsured(insured, isChecked));

  const labelKeyFunc = item => {
    if (item.archivedAt) {
      return `${item.insuredCompanyName} (Archived)`;
    }

    return item.insuredCompanyName;
  };

  return (
    <Box height="inherit">
      <MultiSelectInfiniteList
        data={livingData}
        dataFetchFunction={value => fetchData(value)}
        emptyResultComponent={() => <EmptyInsuredsList />}
        fetchNextData={fetchNextPage}
        hasMore={hasNextPage}
        idKey="insuredId"
        isLoading={rqIsLoading}
        labelKey={labelKeyFunc}
        popoverButtonOnClick={handlePopoverButtonClick}
        popoverButtonShouldPulse={buttonPulse}
        renderArchivedKey="archivedAt"
        scrollHeight="500px"
        toolTipLabel={item => item.insuredId}
        values={selected}
        onSearchTermChange={onSearchTermChange}
        onSelect={(insured, isChecked) => onSelect(insured, isChecked)}
      />
    </Box>
  );
};

export default MultiSelectInsureds;
